import { useState, useEffect } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { fetchticketList } from "./ticketSlice";
import { selectCurrentUser } from "../auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { Filter, Search } from "lucide-react";
import useDebounce from "../../hooks/useDebounce";
import { Link } from "react-router-dom";

export default function Ticket() {
  useDocumentTitle('Ticket List');
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const { fetcticketListtatus, TicketListData } = useSelector((state) => state.tickets);
  const perPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tickets, setTickets] = useState([]);
  const [filters, setFilters] = useState({
    status: "",
    service: "",
    search: ""
  });
  const debouncedSearch = useDebounce(filters.search, 1000);

  const FetchTicketList = async () => {
    const params = {
      status: filters.status,
      service: filters.service,
      search: debouncedSearch
    };
    dispatch(fetchticketList({ params, perPage, currentPage }));
  };

  useEffect(() => {
    FetchTicketList();
  }, [filters.status, filters.service, debouncedSearch, currentPage]);



  useEffect(() => {
    setTickets(TicketListData);
  }, [TicketListData, fetcticketListtatus]);

  console.log(filters);

  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">

          <div className="bg-white p-6 rounded-xl shadow">

            {/* Filters */}
            <div className="flex flex-wrap items-center gap-3 mb-4 justify-between">
              <div className="relative">
                <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                <input
                  placeholder="Search Ticket #"
                  className="border rounded-lg pl-9 pr-3 py-2"
                  onChange={e => setFilters({ ...filters, search: e.target.value })}
                />
              </div>

              <select
                className="border rounded-lg px-3 py-2"
                onChange={e => setFilters({ ...filters, service: e.target.value })}
              >
                <option value="">All Services</option>
                <option value="1">Flight</option>
                <option value="2">Hotel</option>
                <option value="3">Package</option>
              </select>

              <select
                className="border rounded-lg px-3 py-2"
                onChange={e => setFilters({ ...filters, status: e.target.value })}
              >
                <option value="">All Status</option>
                <option value="Open">Open</option>
                <option value="Assigned">Assigned</option>
                <option value="Resolved">Resolved</option>
                <option value="Closed">Closed</option>
              </select>
              <div className="relative inline-block text-left">

                <Link
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 bg-blue-600 text-white `}
                  to='/ticket/create-ticket'>
                  New Ticket
                </Link>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100 text-left">
                  <tr>
                    <th className="p-3">Ticket #</th>
                    <th className="p-3">Service</th>
                    <th className="p-3">Issue</th>
                    <th className="p-3">Status</th>
                    <th className="p-3">Priority</th>
                    <th className="p-3">Created</th>
                  </tr>
                </thead>

                <tbody>
                  {fetcticketListtatus === "loading" ? (
                    <>
                      <tr className="border-b">
                        <td className="px-3 py-2 border" colSpan={12}>
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                          <ShimmerLoader />
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {tickets?.length > 0 ? (
                        tickets.map(ticket => (
                          <tr
                            key={ticket.id}
                            className="border-b hover:bg-gray-50 cursor-pointer"
                          >
                            <td className="p-3 font-semibold text-indigo-600">
                              <Link to={`/ticket/${ticket.id}`}>
                                {ticket.ticket_number}
                              </Link>

                            </td>
                            <td className="p-3">{ticket.service.name}</td>
                            <td className="p-3">{ticket.issue_type.name}</td>
                            <td className="p-3">
                              <span className="px-2 py-1 rounded text-xs bg-gray-200">
                                {ticket.status.name}
                              </span>
                            </td>
                            <td className="p-3">{ticket.priority.name}</td>
                            <td className="p-3">
                              {new Date(ticket.created_at).toLocaleDateString()}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <>
                          <tr className="border-b">
                            <td colSpan={12} className="px-3 py-2 border">
                              No record found
                            </td>
                          </tr>
                        </>
                      )}
                    </>
                  )}

                </tbody>
              </table>
            </div>
          </div>
        </main>

      </div>

    </>
  );
}
